import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticlePreview from './components/ArticlePreview';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <AboutSection />
      <ArticlePreview />
      <CTASection />
      <TestimonialSection />
      <Footer />
    </main>
  );
}